import { Action, Dispatch, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "slices";
import { setIsLoading, setRbacData, setRbacError } from "./reducer";
import rolesData from "../../assets/userRoles/rolesData.json";

export const getRolesData =
  (): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    
    try {
    //   dispatch(setIsLoading(true));
    //   const response: any = await getJewelleriesApi(body);
      const response: any = rolesData;
      
      // dispatch(setIsLoading(false));
      dispatch(setRbacData(response.extensions));
    } catch (error: any) {
      // dispatch(setIsLoading(false));
      dispatch(setRbacError(error));
    } finally {
    //   dispatch(setIsLoading(false)); // End loading
    }
  };